module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Settings-5cfbf532859d85503a20ed91f4d1e317.svg";